import React, { Component, Link } from 'react';
import NotificationSystem from 'react-notification-system';
import ReactTable from 'react-table';
import {
    _addNotification, _addNotificationError,
    showFile, convertTwoDecimalPoint
} from "../../../server/util";
import { currency_symbol } from '../../../server/constants'
import { get } from "../../../server/actions";
import { BeatLoader } from 'react-spinners';
import moment from 'moment';
import _ from 'lodash'
class LowBalReport extends Component {
    constructor(props) {
        super(props)
        this.state = {
            loading: false,

        }
        this.downloadPDF = this.downloadPDF.bind(this);
    }
    downloadPDF = (row) => {
        let _self = this;
        let sDate = moment().subtract('4', 'week').utc().format("YYYY-MM-DDTHH:mm:ss");
        let eDate = moment().utc().format("YYYY-MM-DDTHH:mm:ss");
        let sid = row.userId;
        this.setState({ loading: true });
        get('/reports/lowBalanceStudentDetailsReport?studentRecId=' + sid + '&startDate=' + sDate + '&endDate=' + eDate + '&access_token=').then((response) => {
            if (!response.ok) {
                if (response.status === 417) {
                    return response.json();
                }
                //throw Error(response.errorMessage);
            }
            console.log('response', response);
            return response;
        }).then(res => {
            if (res.statusCode === 417) {
                // _addNotificationError(res.statusMessage,this)
                throw Error(res.statusMessage);
            } else if (!res.statusCode === 200) {
                throw Error(res.errorMessage);
            } else {
                return res.blob();
            }
        }).then(data => {
            let filename = 'Low_balance_report-' + sid + '.pdf';
            showFile(data, filename);
            this.setState({ loading: false });
        }).catch(
            (error) => {
                let msg = ''
                if (typeof error === 'string') {
                    msg = error;
                } else {
                    msg = error.message;
                }
                _addNotificationError(msg, _self)
                //console.log('Get Excel File response', error)
                this.setState({ loading: false })
            }
        );

    }
    render() {
        const checkboxProps = {

            getTheadProps: () => {
                return {
                    style: {
                        backgroundColor: "#D2D7D4", fontWeight: 'bold'
                        // color: selected ? 'white' : 'inherit',
                    },
                    className: "bg-success base-reverse"
                };
            },
            getTableProps: () => {
                return {
                    className: "table table-hover"
                }
            },
        };
        return (<div>
            <div className='sweet-loading'
                style={{ position: 'fixed', top: '50%', left: '48%', zIndex: '1000   ' }}>
                <BeatLoader
                    size={20}
                    color={'#ea7066'}
                    loading={this.state.loading}
                />
            </div>
            <div className="col-md-12">
                <ul style={{ WebkitColumnCount: 3, MozColumnCount: 3, columnCount: 3, textAlign: 'center' }}>
                    <li><label className="color-1">{'Total Records: '}</label>  <strong className="color-4">{this.props.lowBalData.length}</strong></li>

                </ul>
            </div>
            <ReactTable
                filterable
                columns={[
                    {
                        Header: "Student First name",
                        id: 'firstName',
                        accessor: 'firstName',
                        width: 200,
                        style: { textAlign: 'center' },
                        filterMethod: (filter, row) => {
                            const _row = row._original
                            return (_row.firstName || '').toLowerCase().startsWith(filter.value.toLowerCase())
                        },

                    },
                    {
                        Header: "Student Last Name",
                        id: 'lastName',
                        accessor: 'lastName',
                        width: 200,
                        style: { textAlign: 'center' },
                        filterMethod: (filter, row) => {
                            const _row = row._original
                            return (_row.lastName || '').toLowerCase().startsWith(filter.value.toLowerCase())
                        },

                    },
                    {
                        Header: "Student Id",
                        accessor: 'studentId',
                        style: { textAlign: 'center' },
                        filterMethod: (filter, row) => {
                            const _row = row._original
                            return (_row[filter.id]).toLowerCase().startsWith(filter.value.toLowerCase())
                        }
                    },
                    {
                        Header: "Pin",
                        accessor: 'pin',
                        style: { textAlign: 'center' },
                        filterMethod: (filter, row) => {
                            const _row = row._original
                            return (_row[filter.id]).toLowerCase().startsWith(filter.value.toLowerCase())
                        }
                    },
                    {
                        Header: "Parent",
                        id: "parent",
                        style: { textAlign: 'center' },
                        accessor: row => {
                            return (
                                <span>
                                    {row.userName}
                                </span>
                            );
                        },
                        filterMethod: (filter, row) => {
                            const _row = row._original
                            return (_row["userName"]).toLowerCase().startsWith(filter.value.toLowerCase())
                        }
                    },
                    {
                        Header: "Teacher",
                        accessor: "teacherName",
                        width: 150,
                        style: { textAlign: 'center' },
                        filterMethod: (filter, row) => {
                            const _row = row._original
                            return (_row[filter.id]).toLowerCase().startsWith(filter.value.toLowerCase())
                        }

                    },
                    {
                        Header: `Amount (${currency_symbol()})`,
                        id: 'amount',
                        width: 200,
                        filterable: false,
                        accessor: row => {
                            return (
                                <div style={{ textAlign: "center" }}>
                                    {currency_symbol() + ' ' + convertTwoDecimalPoint(row.accBalance)}
                                </div>
                            );
                        }
                    }
                    , {
                        Header: "Action",
                        width: 100,
                        filterable: false,
                        Cell: (row) => {
                            return (
                                <div style={{ textAlign: "center" }}>
                                    <a title="Click to Download PDF"
                                        onClick={() => { this.downloadPDF(row.original) }//this.quickReports('Pdf','currentDay')
                                        } target='_blank'
                                        className="fa fa-file-pdf-o fa-2x QuickReports-PDF"><i /></a>
                                </div>
                            )
                        }
                    }

                ]} data={_.orderBy(this.props.lowBalData, ['studentLName', 'studentFName'], ['asc'])} defaultPageSize={10} className="-striped -highlight" {...checkboxProps} />
        </div>)
    }
}
export default LowBalReport;


// WEBPACK FOOTER //
// ./src/components/SchoolAdmin/PaymentReports/LowBalReport.jsx